// Perfil propio: cualquier usuario edita su nombre/email y cambia su
// contraseña. Disponible para todos los roles (admin/gestor/técnico web).
import { useState, type FormEvent } from 'react';
import { api, ApiError } from '../api.js';
import { useAuth } from '../auth.js';

export function Perfil() {
  const { user, refresh } = useAuth();
  const [nombre, setNombre] = useState(user?.nombre ?? '');
  const [email, setEmail] = useState(user?.email ?? '');
  const [aviso, setAviso] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  const [actual, setActual] = useState('');
  const [nueva, setNueva] = useState('');
  const [avisoPass, setAvisoPass] = useState<string | null>(null);
  const [errorPass, setErrorPass] = useState<string | null>(null);

  const flash = (set: (v: string | null) => void, m: string) => {
    set(m); window.setTimeout(() => set(null), 4000);
  };

  async function guardarPerfil(e: FormEvent) {
    e.preventDefault();
    setError(null);
    try {
      await api.actualizarPerfil(nombre, email);
      await refresh();
      flash(setAviso, 'Perfil actualizado.');
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'No se pudo guardar.');
    }
  }

  async function cambiarPass(e: FormEvent) {
    e.preventDefault();
    setErrorPass(null);
    try {
      await api.cambiarPassword(actual, nueva);
      setActual(''); setNueva('');
      flash(setAvisoPass, 'Contraseña cambiada.');
    } catch (err) {
      setErrorPass(err instanceof ApiError ? err.message : 'No se pudo cambiar la contraseña.');
    }
  }

  return (
    <div className="page">
      <h2>Mi perfil</h2>

      <form className="alta-card" onSubmit={guardarPerfil}>
        <h3>Datos personales</h3>
        {aviso && <div className="aviso-box">{aviso}</div>}
        {error && <div className="error-box">{error}</div>}
        <div className="alta-grid">
          <label className="field">
            <span>Nombre</span>
            <input value={nombre} onChange={(e) => setNombre(e.target.value)} required />
          </label>
          <label className="field">
            <span>Email</span>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
          </label>
        </div>
        <button className="btn-primary inline" type="submit">Guardar perfil</button>
      </form>

      <form className="alta-card" onSubmit={cambiarPass}>
        <h3>Cambiar contraseña</h3>
        {avisoPass && <div className="aviso-box">{avisoPass}</div>}
        {errorPass && <div className="error-box">{errorPass}</div>}
        <div className="alta-grid">
          <label className="field">
            <span>Contraseña actual</span>
            <input type="password" value={actual} onChange={(e) => setActual(e.target.value)}
              autoComplete="current-password" required />
          </label>
          <label className="field">
            <span>Nueva contraseña (mín. 6)</span>
            <input type="password" value={nueva} onChange={(e) => setNueva(e.target.value)}
              autoComplete="new-password" required />
          </label>
        </div>
        <button className="btn-primary inline" type="submit">Cambiar contraseña</button>
      </form>
    </div>
  );
}
